import React, { ReactNode,} from 'react';
import { Link } from 'react-router-dom';
import { Images } from '../../assets/assets';
import { motion, AnimatePresence } from 'framer-motion';

interface DropdownProps {
  label: string | ReactNode;
  items: { path: string, label: string }[];
  isShopMenu?: boolean;
  path: string;
  isOpen: boolean;
  setIsOpen: Function;
  toggle?: Function;
}

const Dropdown: React.FC<DropdownProps> = ({ label, items, isShopMenu, toggle, isOpen, setIsOpen }) => {
  // Dropdown menu animation variants
  const menuVariants = {
    hidden: { 
      opacity: 0, 
      y: -20,
      transition: { duration: 0.2 }
    },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { 
        type: "spring", 
        stiffness: 300, 
        damping: 20 
      }
    }
  };

  // Shop menu animation variants
  const shopMenuVariants = {
    hidden: { 
      opacity: 0, 
      scale: 0.95,
      transition: { duration: 0.2 }
    },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { 
        type: "spring", 
        stiffness: 250, 
        damping: 20 
      }
    }
  };

  return (
    <div className="relative w-full">
      <motion.button 
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => toggle!()} 
        className="btn bg-transparent border-none hover:bg-transparent"
      >
        {label}
      </motion.button>

      <AnimatePresence>
        {isOpen && !!items.length && !isShopMenu && (
          <motion.ul
            variants={menuVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            className="p-2 shadow menu dropdown-content z-50 bg-white text-black rounded-box w-52 absolute top-full right-0"
          >
            {items.map((item, index) => (
              <motion.li 
                key={index}
                whileHover={{ x: 10, transition: { duration: 0.2 } }}
              >
                <Link to={item.path}>{item.label}</Link>
              </motion.li>
            ))}
          </motion.ul>
        )}
        
        {isOpen && isShopMenu && !!items.length && (
          <motion.div
            variants={shopMenuVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            className="p-4 shadow z-50 bg-white text-black rounded-box absolute top-16 left-[-15rem] w-[60vw]"
          >
            <div className="flex w-full gap-4">
            
              {[
                { path: '/water-makers', bg: 'bg-[#005D6E]', title: 'Sparkling Water Makers', img: Images.TerraBlackNavbar },
                { path: '/spare', bg: 'bg-[#EEEAE5]', titleColor: 'text-[#005D6E]', title: 'Gas', imgs: [Images.GasNavbar1, Images.GasNavbar2] },
                { path: '/flavours', bg: 'bg-[#E3E3E3]', titleColor: 'text-[#005D6E]', title: 'Flavours', imgs: [Images.Navbar01, Images.Navbar02] },
                { path: '/accessories', bg: 'bg-[#75A7AD]', title: 'Bottles', imgs: [Images.Navbar4, Images.Navbar42] }
              ].map((item, index) => (
                <motion.div
                  key={index}
                  whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
                  className={`${item.bg} rounded-md basis-[24%] px-2 pt-4 relative`}
                >
                  <Link to={item.path}>
                    <h4 className={`${item.titleColor || 'text-white'} text-[12px] mb-2 font-bold`}>{item.title}</h4>
                    {item.img && <img src={item.img} alt={`${item.title} Nav`} />}
                    {item.imgs && (
                      <div className="flex gap-0 absolute bottom-0 left-1/2" style={{ transform: 'translateX(-50%)' }}>
                        {item.imgs.map((img, imgIndex) => (
                          <img 
                            key={imgIndex} 
                            src={img} 
                            alt={`${item.title} Navbar`} 
                            style={{ width: item.imgs.length > 1 ? '50%' : '80%' }} 
                          />
                        ))}
                      </div>
                    )}
                  </Link>
                </motion.div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Dropdown;